import get from "lodash/get";
import round from "lodash/round";

// PPD is Price Value / Real Price
const getPricePercentageDifference = (product, country, ignorePriceChange) => {
  if (ignorePriceChange) return 1;

  const price = get(product, `prices.${country}.PRICE`, 0);
  const value = get(product, `prices.${country}.VALUE`, 0);

  if (!price || !value) return 1;

  return round(value / price, 6);
};

// Product Value is PPD (above) * Price Weight (Range of -10% - 10%)
const getProductValues = (products, state) => {
  const { country } = state;

  const ignorePriceChange = get(state, "quiz.ignorePriceChange", false);

  return products.map(product => {
    const ppd = getPricePercentageDifference(
      product,
      country,
      ignorePriceChange
    );

    const weight = get(product, `prices.${country}.WEIGHT`, 1);

    let productValue = round(ppd * weight, 6);
    productValue = Math.min(Math.max(productValue, 0.9), 1.1);

    return { ...product, productValue };
  });
};

export default getProductValues;
